import React, { useEffect, useState } from "react";
import Graph from "./Graph";
import CardDiv from "modules/common/card-div/CardDiv";
import { Form } from "react-bootstrap";
import NoData from "assets/svgs/no_data/NoData";
import {reduceArray} from "modules/utilities/utility"

function ExotelStats({ stats, setDownloadData, proStats }) {
  const [talkTime, setTalkTime] = useState({});
  const [completed, setCompleted] = useState({});
  const [attempts, setAttempts] = useState({});
  const [talkTimeForPro, setTalkTimeForPro] = useState({});
  const [completedForPro, setCompletedForPro] = useState({});
  const [attemptsForPro, setAttemptsForPro] = useState({});
  const [dataType, setDataType] = useState("Split");

  useEffect(() => {
    setDownloadData("stats");
    setTalkTime(reduceArray(stats, "duration"));
    setCompleted(reduceArray(stats, "answered"));
    setAttempts(reduceArray(stats, "attempts"));

    setTalkTimeForPro(reduceArray(proStats, "duration"));
    setCompletedForPro(reduceArray(proStats, "answered"));
    setAttemptsForPro(reduceArray(proStats, "attempts"));
  }, [stats, proStats]);



  return (
    <div
      style={{ height: "75vh", overflowY: "scroll" }}
      className="p-3  d-flex flex-column gap-3 scrollable-container "
    >
      <div className="d-flex justify-content-end mx-2">
        <Form.Check
          type="switch"
          id="checkedSwitch"
          label={`Switch to ${dataType === "Split" ? "Aggregate" : "Split"}`}
          onClick={() => {
            setDataType((prevDataType) =>
              prevDataType === "Split" ? "Aggregate" : "Split"
            );
          }}
        />
      </div>

      <CardDiv
        component={
          Object.entries(completed).length ? (
            <Graph data={dataType === "Split" ? completed : completedForPro} />
          ) : (
            <h3 className="d-flex gap-3 align-items-center justify-content-center h-100">
              <span>No data available</span>
              <span>
                <NoData />
              </span>
            </h3>
          )
        }
        title={"Completed Calls"}
      />
      <CardDiv
        component={
          Object.entries(talkTime).length ? (
            <Graph data={dataType === "Split" ? talkTime : talkTimeForPro} />
          ) : (
            <h3 className="d-flex gap-3 align-items-center justify-content-center h-100">
              <span>No data available</span>
              <span>
                <NoData />
              </span>
            </h3>
          )
        }
        title={"Call Duration"}
      />
      <CardDiv
        component={
          Object.entries(attempts).length ? (
            <Graph data={dataType === "Split" ? attempts : attemptsForPro} />
          ) : (
            <h3 className="d-flex gap-3 align-items-center justify-content-center h-100">
              <span>No data available</span>
              <span>
                <NoData />
              </span>
            </h3>
          )
        }
        title={"Call Attempts"}
      />
    </div>
  );
}

export default ExotelStats;
